
import { AlertCircle } from "lucide-react";

export function ApiTestingTips() {
  return (
    <div className="rounded-md bg-yellow-50 p-4 mb-4 border border-yellow-200">
      <div className="flex">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-yellow-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">API Testing Tips</h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p>
              Make sure to use a valid bill component ID from the database. The API will check if the bill exists before updating its status.
              If you're experiencing errors, verify that:
            </p>
            <ul className="list-disc pl-5 mt-2">
              <li>The bill component ID exactly matches one in the database</li>
              <li>The bill hasn't already been paid or cancelled</li>
              <li>You're using the correct action ('paid' or 'cancel')</li>
            </ul>
            <p className="mt-2">
              <strong>Note:</strong> For testing purposes, a test API key is automatically included in the request. In production, 
              a valid PAYMENT_API_KEY would be required for authorization.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
